// extracted by mini-css-extract-plugin
export default {"infiniteScroll":"MovieList_infiniteScroll__aWdn-","container":"MovieList_container__QnWFT"};